/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Index_Collection_Section_TitleInputs */

const en_directory_taxonomy_index_collection_section_title = /** @type {(inputs: Directory_Taxonomy_Index_Collection_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse collections`)
};

const zh_directory_taxonomy_index_collection_section_title = /** @type {(inputs: Directory_Taxonomy_Index_Collection_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览合集`)
};

/**
* | output |
* | --- |
* | "Browse collections" |
*
* @param {Directory_Taxonomy_Index_Collection_Section_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_index_collection_section_title = /** @type {((inputs?: Directory_Taxonomy_Index_Collection_Section_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Index_Collection_Section_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_index_collection_section_title(inputs)
	return zh_directory_taxonomy_index_collection_section_title(inputs)
});
export { directory_taxonomy_index_collection_section_title as "directory.taxonomy_index.collection.section_title" }